// extracted by mini-css-extract-plugin
export var faqs = "accordiongroup-module--faqs--9cdcd";
export var inner = "accordiongroup-module--inner--7cab4";
export var sidebar = "accordiongroup-module--sidebar--83fb8";